var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterlevelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.32 16L24 4.70001L12.68 16C9.56 19.12 8 23.28 8 27.28C8 31.28 9.56 35.5 12.68 38.62C15.8 41.74 19.9 43.32 24 43.32C28.1 43.32 32.2 41.74 35.32 38.62C38.44 35.5 40 31.28 40 27.28C40 23.28 38.44 19.12 35.32 16ZM12 28C12.02 24 13.24 21.46 15.52 19.2L24 10.54L32.48 19.3C34.76 21.54 35.98 24 36 28H12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterlevelIcon);
export default __webpack_public_path__ + "static/media/waterlevelIcon.e6b1a10efb48aeccf058908827f68c5d.svg";
export { ForwardRef as ReactComponent };